module.exports = __webpack_public_path__ + "img/18-white.6686432e.svg";